import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import { useAtom } from 'jotai'
import React from 'react'

import { useLogEvent } from '~/hooks/useLogEvent'
import { toggleItem } from '~/utils'

import { hiddenSurveyIdsAtom } from '../../atoms'
import { type Survey } from '../../hooks/useMainQuery'

export type SurveyCheckboxProps = {
  survey: Survey
}

export const SurveyCheckbox = ({ survey }: SurveyCheckboxProps) => {
  const [hiddenSurveyIds, setHiddenSurveyIds] = useAtom(hiddenSurveyIdsAtom)

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(() => {
    setHiddenSurveyIds(toggleItem(survey.id))
    logEvent('Change surveys to be displayed', {
      eventProperties: [{ key: 'survey', value: survey.title }],
    })
  }, [logEvent, setHiddenSurveyIds, survey.id, survey.title])

  return (
    <Checkbox
      checked={!hiddenSurveyIds.includes(survey.id)}
      label={survey.title}
      onChange={handleChange}
    />
  )
}
